import axios from '../utils/axios';

export default function changePassword(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/change-password', data)
    )
}
